import "../DashboardQuiz/DashboardQuiz.scss";

import { useState } from "react";
import { HiOutlineSparkles } from "react-icons/hi2";
import { FiGitBranch } from "react-icons/fi";
import { IoMdClose } from "react-icons/io";

import { useSelectVehicleContext } from "../../contexts/selectVehicleContext";
import { fetchVehicleTrims } from "../../services/dealership";

import ButtonPlain from "../ButtonPlain/ButtonPlain";
import TrimComparisonChart from "../TrimComparisonChart/TrimComparisonChart";
import { useUserTrackingContext } from "../../contexts/userTrackingContext";

export default function VPOGTrimComparison({
  quizQuestions,
  currentQuestionViewIndex,
  dealershipId,
}) {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [vehicleTrims, setVehicleTrims] = useState([]);

  const { trackEvent } = useUserTrackingContext();
  const { vehicleVPOGUrl } = useSelectVehicleContext();

  async function handleVehicleTrimsCompare(e, params) {
    e.preventDefault();

    const data = await fetchVehicleTrims(dealershipId, params);
    setVehicleTrims(data.trims);

    setDialogOpen(true);
  }

  function extractVehicleString(value) {
    const [year, make, model] = value
      .split("&")
      .map((pair) => pair.split("=")[1]);
    return `${year} ${make} ${model.replace(/\+/g, " ")}`;
  }

  return (
    <div>
      <div className="quiz__options_cards two_wider_cards">
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: 5,
          }}
        >
          <HiOutlineSparkles />

          <p>What would you like to compare?</p>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: 10,
          }}
        >
          {vehicleVPOGUrl?.length > 0 && (
            <ButtonPlain
              onClick={async (e) => {
                e.preventDefault();
                const vehicleStr = extractVehicleString(
                  quizQuestions[currentQuestionViewIndex]?.children[0]
                    ?.inputValue
                );
                await trackEvent({
                  eventName: "CLICKED_VPOG",
                  domain: "dealer-sales-copilot",
                  role: "SALESPERSON",
                  payload: {
                    vehicle: vehicleStr,
                  },
                });
                window.open(vehicleVPOGUrl);
              }}
              style={{
                borderRadius: "10px",
                border: "none",
                display: "flex",
                flex: 1,
                justifyContent: "center",
                alignItems: "center",
                gap: 2,
                fontWeight: "600",
              }}
            >
              <FiGitBranch fontWeight="600" />
              {extractVehicleString(
                quizQuestions[currentQuestionViewIndex]?.children[0]?.inputValue
              )}{" "}
              VPOG
            </ButtonPlain>
          )}

          <ButtonPlain
            onClick={async (e) => {
              e.preventDefault();
              const vehicleStr = extractVehicleString(
                quizQuestions[currentQuestionViewIndex]?.children[0]?.inputValue
              );
              await trackEvent({
                eventName: "CLICKED_TRIM_COMPARISON_CHART",
                role: "SALESPERSON",
                domain: "dealer-sales-copilot",
                payload: {
                  vehicle: vehicleStr,
                },
              });
              handleVehicleTrimsCompare(
                e,
                quizQuestions[currentQuestionViewIndex]?.children[0]?.inputValue
              );
            }}
            style={{
              borderRadius: "10px",
              border: "none",
              display: "flex",
              flex: 1,
              justifyContent: "center",
              alignItems: "center",
              gap: 2,
              fontWeight: "600",
            }}
          >
            <FiGitBranch fontWeight="600" />
            {extractVehicleString(
              quizQuestions[currentQuestionViewIndex]?.children[0]?.inputValue
            )}{" "}
            Trims
          </ButtonPlain>
        </div>

        {dialogOpen && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 9999,
            }}
          >
            <div
              style={{
                backgroundColor: "#fff",
                borderRadius: "10px",
                width: "70%",
                position: "relative",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "0.5rem",
                }}
              >
                <p
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 3,
                    fontWeight: "600",
                  }}
                ></p>
                <button
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                    borderRadius: "5px",
                    border: "1px solid #e5e5e5",
                    paddingTop: "0.5em",
                    paddingBottom: "0.5em",
                    paddingInline: "1em",
                    backgroundColor: "white",
                  }}
                  onClick={() => setDialogOpen(false)}
                >
                  <IoMdClose />
                  Close
                </button>
              </div>
              <div
                style={{
                  overflowY: "scroll",
                  maxHeight: "600px",
                }}
              >
                <TrimComparisonChart trims={vehicleTrims} />
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
